/**
 * Created by h3 on 2018-04-11.
 */
import {ILayerConfig, ILayersConfig} from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import {LayerScaleOption} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";

export class TractorBeamLayerConfig {

    public static defaultLayerScaleOptions:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {
            landscape : LayerScaleOption.FIT_WINDOW
        },
        mobile : {
            landscape : LayerScaleOption.FIT_WINDOW,
            portrait : LayerScaleOption.REELS_FIT_STAGE
        }
    };

    public static BACKGROUND:ILayerConfig = {
        name : "background"
    };

    public static UFO:ILayerConfig = {name : "ufo"};

    public static REEL_BACKGROUND:ILayerConfig = {
        name : "REEL_BACKGROUND"
    };

    public static BACK_PROJECTION:ILayerConfig = {name : "backProjection"};
    public static SYMBOLS:ILayerConfig = {name : "symbols"};
    public static FRONT_PROJECTION:ILayerConfig = {name : "frontProjection"};
    public static REEL_ATTENTION:ILayerConfig = {name : "reelAttention"};
    public static BET_LINES:ILayerConfig = {name : "betLines"};
    // WIN_PRESENTATIONS : {name: "winPresentations"},
    // FOREGROUND : {name: "foreground"},
    public static BIG_WIN:ILayerConfig = {name : "bigWin"};
    public static INTRO:ILayerConfig = {name : "introScreen", scaleOption : LayerScaleOption.FIT_WINDOW};
    public static TWEAK_MODULE:ILayerConfig = {name : "tweakModule", scaleOption : LayerScaleOption.FIT_WINDOW};
    public static FREE_SPIN:ILayerConfig = {name : "freespin"};
    public static FS_SCREEN:ILayerConfig = {name : "FS_SCREEN"};
    public static WIN_COUNT_UP:ILayerConfig = {name : "winCountUp"};
    public static FOREGROUND:ILayerConfig = {name : "foreground"};
    public static FEATURE_TEXT:ILayerConfig = {name : "featureText"};
    public static FADE_WHITE:ILayerConfig = {name : "fadeWhite"};
    public static STICKY_SYMBOL_OVERLAY:ILayerConfig = {name : "stickySymbolOverlay"};
    public static COMMAND_CENTER:ILayerConfig = {name : "commandCenter"};
    //public static INTERACTIVE_PRESENTATION:ILayerConfig = {name: "interactivePresentation"};
    public static RANDOM_STACKS:ILayerConfig = {name : "randomStacks"};

    public static getConfig():ILayersConfig {
        return {
            BACKGROUND : TractorBeamLayerConfig.BACKGROUND,
            UFO : TractorBeamLayerConfig.UFO,
            REEL_BACKGROUND : TractorBeamLayerConfig.REEL_BACKGROUND,
            BET_LINES : TractorBeamLayerConfig.BET_LINES,
            BACK_PROJECTION : TractorBeamLayerConfig.BACK_PROJECTION,
            SYMBOLS : TractorBeamLayerConfig.SYMBOLS,
            REEL_ATTENTION : TractorBeamLayerConfig.REEL_ATTENTION,
            FRONT_PROJECTION : TractorBeamLayerConfig.FRONT_PROJECTION,
            RANDOM_STACKS : TractorBeamLayerConfig.RANDOM_STACKS,
            FOREGROUND : TractorBeamLayerConfig.FOREGROUND,
            FEATURE_TEXT : TractorBeamLayerConfig.FEATURE_TEXT,
            COMMAND_CENTER : TractorBeamLayerConfig.COMMAND_CENTER,
            BIG_WIN : TractorBeamLayerConfig.BIG_WIN,
            TWEAK_MODULE : TractorBeamLayerConfig.TWEAK_MODULE,
            FREE_SPIN : TractorBeamLayerConfig.FREE_SPIN,
            FS_SCREEN : TractorBeamLayerConfig.FS_SCREEN,
            FADE_WHITE : TractorBeamLayerConfig.FADE_WHITE,
            WIN_COUNT_UP : TractorBeamLayerConfig.WIN_COUNT_UP,
            STICKY_SYMBOL_OVERLAY : TractorBeamLayerConfig.STICKY_SYMBOL_OVERLAY,
            //INTERACTIVE_PRESENTATION : TractorBeamLayerConfig.INTERACTIVE_PRESENTATION,
            INTRO : TractorBeamLayerConfig.INTRO
        }
    }
}
